import {Button, ButtonGroup, Form} from "react-bootstrap";
import {IconContext} from "react-icons";
import PropTypes from "prop-types";
import {Icons} from "../Icons.jsx";
export const Pagination = ({tableInstance, isServer}) => {

    return (
        <>
            <div
                className={"d-flex flex-nowrap justify-content-between align-items-center gap-3 mb-5 mt-4 pagination"}>
                <div className={"d-flex flex-nowrap gap-2 align-items-center"}>
                    <Form.Select
                        className={'w-100'}
                        size={"sm"} value={tableInstance.options.state.pagination.pageSize}
                                 onChange={(e) => tableInstance.setPageSize(+e.target.value)}>
                        {[10, 20, 50, 100].map((o) => (
                            <option key={o} value={o}>
                                pokaż na stronie: {o}
                            </option>
                        ))}
                    </Form.Select>

                    <div className={'text-muted small fw-bold text-center text-nowrap'}>
                        Znalezione: {tableInstance.getFilteredRowModel().rows.length} z {isServer ? tableInstance.getRowCount() : tableInstance.getPreFilteredRowModel().rows.length}{" "}

                    </div>

                </div>

                <IconContext.Provider value={{size: 10}}>
                    <div className='d-flex flex-wrap'>
                        <ButtonGroup>
                            <Button
                                size={'sm'}
                                variant={'outline-primary'}
                                title={'idź do pierwszej'}
                                disabled={!tableInstance.getCanPreviousPage()}
                                onClick={() => {
                                    tableInstance.setPageIndex(0)
                                    // gotoPage(0)
                                }}>
                                <Icons.doubleLeft color={'#021f4f'}/>
                            </Button>

                            <Button
                                size={'sm'}
                                variant={'outline-primary'}
                                title={'idź do poprzedniej'}
                                disabled={!tableInstance.getCanPreviousPage()}
                                onClick={() => {
                                    // setPageNumber(pageNumber - 1)
                                    tableInstance.previousPage()
                                }}>
                                <Icons.left color={'#021f4f'}/>
                            </Button>
                        </ButtonGroup>
                        <div className={"d-flex flex-wrap align-items-center gap-1 ms-2"}>
                            <div>
                                <strong>
                                    {/*{pageIndex + 1} z {pageOptions.length}{" "}*/}
                                    {tableInstance.options.state.pagination.pageIndex + 1} z {tableInstance.getPageCount()}{" "}
                                </strong>
                            </div>
                            <div>| idź do:</div>
                            <Form.Control
                                className={"px-1 flex-shrink-0 rounded-0 me-2"}
                                type={"number"}
                                min={1}
                                max={tableInstance.getPageCount()}
                                style={{width: "55px", textAlign: "center"}}
                                title={'idź do strony'}
                                value={tableInstance.options.state.pagination.pageIndex + 1}
                                onChange={(e) => {
                                    if (+e.target.value <= 0) {
                                        return
                                    }
                                    const pageCount = tableInstance.getPageCount()
                                    if (+e.target.value > pageCount) {
                                        tableInstance.setPageIndex(pageCount - 1)
                                        return
                                    }
                                    tableInstance.setPageIndex(+e.target.value - 1)
                                }}
                            />
                        </div>
                        <ButtonGroup>
                            <Button
                                size={'sm'}

                                title={'idź do następnej'}
                                variant={'outline-primary'}
                                disabled={!tableInstance.getCanNextPage()}
                                onClick={() => {
                                    // setPageNumber(pageNumber + 1)
                                    tableInstance.nextPage()
                                }}>
                                <Icons.right color={'#021f4f'}/>
                            </Button>

                            <Button
                                size={'sm'}

                                title={'idź do następnej'}
                                variant={'outline-primary'}
                                disabled={!tableInstance.getCanNextPage()}
                                onClick={() =>
                                    tableInstance.setPageIndex(tableInstance.getPageCount() - 1)}>
                                <Icons.doubleRight color={'#021f4f'}/>
                            </Button></ButtonGroup>
                    </div>
                </IconContext.Provider>
            </div>


        </>
    )
}

Pagination.propTypes = {
    tableInstance: PropTypes.object.isRequired,
    isServer: PropTypes.bool,

}